import { render, staticRenderFns } from "./sidebar_menu.vue.js?vue&type=template&id=366699a6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_menu.vue?vue&type=template&id=366699a6"
import script from "./sidebar_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_menu.vue?vue&type=script&lang=js"
export * from "./sidebar_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366699a6')) {
      api.createRecord('366699a6', component.options)
    } else {
      api.reload('366699a6', component.options)
    }
    module.hot.accept("./sidebar_menu.vue.js?vue&type=template&id=366699a6!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_menu.vue?vue&type=template&id=366699a6", function () {
      api.rerender('366699a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/sidebar_menu.vue"
export default component.exports